/* istanbul ignore file */

import React from 'react';

import { authenticatedApiCall } from 'src/utils/apiCall/apiCall';
import { logError } from 'src/utils/logError';

interface ErrorAction {
  payload: string;
  type: 'error';
}

interface LoadingAction {
  type: 'loading';
}

interface SuccessAction {
  payload: 'LOGGED_OUT' | 'LOGGED_IN' | 'LOGGED_IN_AND_APPLIED';
  type: 'success';
}

type Action = LoadingAction | SuccessAction | ErrorAction;

interface State {
  applied: boolean;
  error: null | string;
  status: 'idle' | 'loading' | 'success' | 'error';
}

const initialState: State = {
  applied: false,
  status: 'idle',
  error: null,
};

function reducer(state: State, action: Action): State {
  switch (action.type) {
    case 'loading':
      return { ...state, status: 'loading' };
    case 'success':
      const userState = action.payload;
      return {
        ...state,
        applied: userState === 'LOGGED_IN_AND_APPLIED',
        status: 'success',
        error: null,
      };
    case 'error':
      return { ...state, status: 'error', error: action.payload };
  }
}

export const useUserAppliedState = () => {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  const { applied, error, status } = state;

  React.useEffect(() => {
    const getUserState = async () => {
      try {
        dispatch({ type: 'loading' });
        const { data } = await authenticatedApiCall({ url: '/users-state' });

        // @ts-ignore
        dispatch({ type: 'success', payload: data.userState });
      } catch (error) {
        logError(error as Error);
        dispatch({ type: 'error', payload: 'request failed' });
      }
    };

    if (status === 'idle') {
      getUserState();
    }
  }, [status]);

  return { applied, status, errorMessage: error };
};
